import React from 'react';
import { Select } from 'antd';
import './public-component.less';

export enum ProjectStatus {
    waiting = 0,
    running = 1,
    terminated = 2,
    completed = 3,
}

interface ProjectStatusSelectProps {
    value?: number | number[];
    onChange?: (value: any) => void;
    allowClear?: boolean;
    mode?: 'multiple' | undefined;
    placeholder?: string;
}

const options = [
    { value: ProjectStatus.waiting, label: '待开始' },
    { value: ProjectStatus.running, label: '进行中' },
    { value: ProjectStatus.terminated, label: '提前终止' },
    { value: ProjectStatus.completed, label: '完成' },
];

export const getProjectStatusText = (value: number) => {
    const found = options.find(item => item.value === value);
    return found ? found.label : '其他';
};

const ProjectStatusSelect: React.FC<ProjectStatusSelectProps> = ({
    value,
    onChange,
    allowClear,
    mode,
    placeholder,
}) => {
    return (
        <Select
            className="select-project_status"
            mode={mode}
            value={value}
            onChange={onChange}
            allowClear={allowClear}
            placeholder={placeholder || '请选择项目状态'}
        >
            {options.map(option => (
                <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
            ))}
        </Select>
    );
};

export default ProjectStatusSelect;
